import React from "react";
import { Box } from "@mui/material";
import AreaChart from "../../AreaChart";
import HorizontalBarList from "../../HorizontalBarList";
import InfoCard from "../../InfoCard";
import {
  SupplierOverviewResponse,
  SupplierWithMostContractsItem,
} from "../../../../types/suppliers";
import styles from "./analyticsDashboard.module.scss";

interface AnalyticsDashboardProps {
  overviewData: SupplierOverviewResponse;
  suppliersWithMostContracts: SupplierWithMostContractsItem[];
}

const AnalyticsDashboard: React.FC<AnalyticsDashboardProps> = ({
  overviewData,
  suppliersWithMostContracts,
}) => {
  const formatCurrency = (value: number): string => {
    if (value >= 1000000) {
      return `$${(value / 1000000).toFixed(2)}M`;
    } else if (value >= 1000) {
      return `$${(value / 1000).toFixed(1)}K`;
    }
    return `$${value}`;
  };

  return (
    <>
      <Box className={styles.chartsSection}>
        <AreaChart
          title="DD Initiated by Month"
          data={overviewData.initiatedByMonth || []}
          xAxisKey="month"
          areas={[
            { dataKey: "count", color: "#5b6b9e", label: "DD Initiated" },
          ]}
        />
        <AreaChart
          title="DD Approval by Month"
          data={overviewData.approvalByMonth || []}
          xAxisKey="month"
          areas={[{ dataKey: "count", color: "#00d2aa", label: "DD Approved" }]}
        />
      </Box>

      <Box className={styles.listsSection}>
        <HorizontalBarList
          title="Top Spend Suppliers"
          data={overviewData.topSpendSuppliers || []}
          labelKey="supplierName"
          valueKey="totalSpend"
          valueFormatter={formatCurrency}
        />
        <HorizontalBarList
          title="Suppliers with Most Contracts"
          data={suppliersWithMostContracts || []}
          labelKey="supplierName"
          valueKey="contractsCount"
        />
      </Box>

      <Box className={styles.infoCardsSection}>
        <InfoCard
          type="region"
          title="Suppliers in UAE Region"
          value={overviewData.primaryCards.uaeRegionSuppliers?.count || 0}
          subtitle={overviewData.primaryCards.uaeRegionSuppliers?.label || "UAE Region Suppliers"}
        />
        <InfoCard
          type="new_suppliers"
          title="Registered in 2026"
          value={overviewData.primaryCards.registeredSuppliersInSpecificYear?.count || 0}
          subtitle={overviewData.primaryCards.registeredSuppliersInSpecificYear?.label || "New suppliers this year"}
        />
      </Box>
    </>
  );
};

export default AnalyticsDashboard;
